<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::navbar-->
      <navbar-component></navbar-component>
      <!--end::navbar-->

      <div class="page-wrapper">
        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="card-title mb-0 float-start" style="padding-left: 25px">
                    {{ $t("tarifMasterDetail") }}
                  </h6>
                  <button class="btn btn-light float-end" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                    <i class="link-icon" data-feather="info"></i>
                    Audit Info
                  </button>
                  <div class="row mb-3 collapse" id="collapseExample" style="padding-left: 20px">
                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Created By:</label>
                      <p class="text-muted">{{ this.forms.addwho }}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Created At:</label>
                      <p class="text-muted">{{ this.forms.adddate }}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated By:</label>
                      <p class="text-muted">{{ this.forms.editwho }}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated At:</label>
                      <p class="text-muted">{{ this.forms.editdate }}</p>
                    </div>
                  </div>
                </div>

                <div class="card-body">

                  <div class="row mb-3">
                    <!-- kolom kiri -->
                    <div class="col-lg-7">
                      <!-- Tariff Master Wms -->
                      <div class="row mb-3">
                        <div class="col-lg-4">
                          <label for="tarifMasterId" class="col-form-label" style="padding-left: 25px">{{
                            $t("tarifMasterId") }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input type="text" class="form-control" id="tarifMasterId" :placeholder="$t('tarifMasterId')"
                            v-model="forms.tarifMasterId" disabled />
                        </div>
                      </div>
                      <!-- Customer ID -->
                      <div class="row mb-3">
                        <div class="col-lg-4">
                          <label for="customerId" class="col-form-label" style="padding-left: 25px">{{
                            $t("customerId")
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input type="text" class="form-control" id="customerId" :placeholder="$t('customerId')"
                            v-model="forms.customerId" disabled />
                        </div>
                      </div>
                      <!-- Query -->
                      <div class="row mb-3">
                        <div class="col-lg-4">
                          <label for="query" class="col-form-label" style="padding-left: 25px">{{ $t("query")
                            }}</label>
                        </div>
                        <div class="col-lg-8">
                          <textarea class="form-control" id="query" :placeholder="$t('query')"
                            v-model="forms.queryRateHeader" rows="10" max-rows="20" disabled></textarea>
                        </div>
                      </div>
                      <!-- Query Storage Beginning Balance -->
                      <div class="row mb-3" v-show="forms.beginningBalanceFlag == 'Y'">
                        <div class="col-lg-4">
                          <label for="queryBeginningBalance" class="col-form-label" style="padding-left: 25px">{{
                            $t("queryBeginningBalance")
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <textarea class="form-control" id="queryBeginningBalance"
                            :placeholder="$t('queryBeginningBalance')" v-model="forms.queryBeginningBalance" rows="10"
                            max-rows="20" disabled></textarea>
                        </div>
                      </div>
                      <!-- Query Rental Pallet Beginning Balance -->
                      <div class="row mb-3" v-show="forms.begBalRentPallFlag == 'Y'">
                        <div class="col-lg-4">
                          <label for="queryBegBalRentPall" class="col-form-label" style="padding-left: 25px">{{
                            $t("queryBegBalRentPall")
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <textarea class="form-control" id="queryBegBalRentPall"
                            :placeholder="$t('queryBegBalRentPall')" v-model="forms.queryBegBalRentPall" rows="10"
                            max-rows="20" disabled></textarea>
                        </div>
                      </div>
                    </div>

                    <!-- kolom kanan -->
                    <div class="col-lg-5">
                      <div class="row mb-3">
                        <div class="col-lg-5">
                          <label for="status" class="col-form-label" style="padding-left: 75px">{{ $t("statusTxt")
                            }}</label>
                        </div>
                        <div class="col-lg-7">
                          <!-- Radio Buttons for Status (Each Radio in its Own Column) -->
                          <div class="row mt-2" style="width:220px">
                            <div class="col" v-for="statusOption in fetchStatus" :key="statusOption"
                              style="display: flex; align-items:center;">
                              <label>
                                <!-- Disable the radio buttons but display the selected one -->
                                <input type="radio" v-model="forms.status" :value="statusOption"
                                  :id="'status-' + statusOption" disabled style="margin-right: 5px;">
                                {{ statusOption }}
                              </label>
                            </div>
                          </div>
                          <!-- Error handling for status -->
                          <div v-if="errors.status">
                            <div v-for="error in errors.status" :key="error" class="alert alert-primary" role="alert">
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-5">
                          <label for="weeklyTransmitFlag" class="col-form-label" style="padding-left: 75px">{{
                            $t("weeklyTransmitFlag") }}</label>
                        </div>
                        <div class="col-lg-7">
                          <!-- Radio Buttons for Weekly Transmit Flag (Each Radio in its Own Column) -->
                          <div class="row mt-2" style="width:220px">
                            <div class="col" style="display: flex; align-items: center;">
                              <label>
                                <!-- Disable the radio buttons but display the selected one -->
                                <input type="radio" v-model="forms.weeklyTransmitFlag" value="Y"
                                  id="weeklyTransmitFlagYes" disabled style="margin-right: 5px;">
                                {{ $t("Yes") }}
                              </label>
                            </div>
                            <div class="col" style="display: flex; align-items: center;">
                              <label>
                                <input type="radio" v-model="forms.weeklyTransmitFlag" value="N"
                                  id="weeklyTransmitFlagNo" disabled style="margin-right: 5px;">
                                {{ $t("No") }}
                              </label>
                            </div>
                          </div>

                          <!-- Error handling for weeklyTransmitFlag -->
                          <div v-if="errors.weeklyTransmitFlag">
                            <div v-for="error in errors.weeklyTransmitFlag" :key="error" class="alert alert-primary"
                              role="alert">
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-5">
                          <label for="multiWhFlag" class="col-form-label" style="padding-left: 75px">{{
                            $t("multi_warehouse_flag") }}</label>
                        </div>
                        <div class="col-lg-7">
                          <!-- Radio Buttons for Multi Warehouse Flag (Each Radio in its Own Column) -->
                          <div class="row mt-2" style="width:220px">
                            <div class="col" style="display: flex; align-items: center;">
                              <label>
                                <!-- Disable the radio buttons but display the selected one -->
                                <input type="radio" v-model="forms.multiWhFlag" value="Y" id="multiWhFlagYes" disabled
                                  style="margin-right: 5px;">
                                {{ $t("Yes") }}
                              </label>
                            </div>
                            <div class="col" style="display: flex; align-items: center;">
                              <label>
                                <input type="radio" v-model="forms.multiWhFlag" value="N" id="multiWhFlagNo" disabled
                                  style="margin-right: 5px;">
                                {{ $t("No") }}
                              </label>
                            </div>
                          </div>

                          <!-- Error handling for multiWhFlag -->
                          <div v-if="errors.multiWhFlag">
                            <div v-for="error in errors.multiWhFlag" :key="error" class="alert alert-primary"
                              role="alert">
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-5">
                          <label for="beginningBalanceFlag" class="col-form-label" style="padding-left: 75px">{{
                            $t("beginningBalanceFlag") }}</label>
                        </div>
                        <div class="col-lg-7">
                          <!-- Radio Buttons for Beginning Balance Flag -->
                          <div class="row mt-2" style="width:220px">
                            <div class="col" style="display: flex; align-items: center;">
                              <label>
                                <!-- Disable the radio buttons but display the selected one -->
                                <input type="radio" v-model="forms.beginningBalanceFlag" value="Y"
                                  id="beginningBalanceFlagYes" disabled style="margin-right: 5px;">
                                {{ $t("Yes") }}
                              </label>
                            </div>
                            <div class="col" style="display: flex; align-items: center;">
                              <label>
                                <input type="radio" v-model="forms.beginningBalanceFlag" value="N"
                                  id="beginningBalanceFlagNo" disabled style="margin-right: 5px;">
                                {{ $t("No") }}
                              </label>
                            </div>
                          </div>
                          <!-- Error handling for beginningBalanceFlag -->
                          <div v-if="errors.beginningBalanceFlag">
                            <div v-for="error in errors.beginningBalanceFlag" :key="error" class="alert alert-primary"
                              role="alert">
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-5">
                          <label for="begBalRentPallFlag" class="col-form-label" style="padding-left: 75px">{{
                            $t("begBalRentPallFlag") }}</label>
                        </div>
                        <div class="col-lg-7">
                          <!-- Radio Buttons for Beginning Balance Flag -->
                          <div class="row mt-2" style="width:220px">
                            <div class="col" style="display: flex; align-items: center;">
                              <label>
                                <!-- Disable the radio buttons but display the selected one -->
                                <input type="radio" v-model="forms.begBalRentPallFlag" value="Y"
                                  id="begBalRentPallFlagYes" disabled style="margin-right: 5px;">
                                {{ $t("Yes") }}
                              </label>
                            </div>
                            <div class="col" style="display: flex; align-items: center;">
                              <label>
                                <input type="radio" v-model="forms.begBalRentPallFlag" value="N"
                                  id="begBalRentPallFlagNo" disabled style="margin-right: 5px;">
                                {{ $t("No") }}
                              </label>
                            </div>
                          </div>
                          <!-- Error handling for begBalRentPallFlag -->
                          <div v-if="errors.begBalRentPallFlag">
                            <div v-for="error in errors.begBalRentPallFlag" :key="error" class="alert alert-primary"
                              role="alert">
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="card-footer">
                    <button class="btn btn-warning text-black fw-bolder btn-icon-text" @click="backForm" type="button">
                      <i class="link-icon mdi mdi-arrow-left"></i>
                      {{ $t("backMess") }}
                    </button>

                    <a v-if="permision_role.method_delete"
                      class="btn btn-danger text-white fw-bolder btn-icon-text float-end" @click="deleteData()">
                      <i class="link-icon" data-feather="trash"></i>
                      {{ $t("deleteMess") }}
                    </a>

                    <a v-if="permision_role.method_update"
                      class="btn btn-primary me-2 text-white fw-bolder btn-icon-text float-end" @click="editData()">
                      <i class="link-icon" data-feather="edit"></i>
                      {{ $t("editMess") }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
  name: "CmlTarifDetail",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      permision_role: [],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      userData: "",
      userRole: "",
      companyCode: "",
      fetchStatus: ["ACTIVE", "DEACTIVE"],
      fetchCustomer: [],
      fetchFulfillment: [],
      customer: "",
      fulfillment: "",
    };
  },
  watch: {},
  methods: {
    deleteData() {
      var id = this.$onBehind(this.$route.params.id);
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataDelete"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            status: status,
          };
          const baseURI =
            this.$settings.endPointBilling +
            "dashboard/cml-billing/bm-tarif-master-cml/delete/" +
            id;
          this.$http
            .delete(baseURI, formData, { timeout: 60000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                window.location.href = "/billing-cml/master-tarif";
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
              this.isLoading = false;
              if (error.code == "ECONNABORTED") {
                this.error("Please Check Your Internet Connection");
              }

              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 401) {
                  this.logout();
                } else if (error.response.status === 403) {
                  this.$router.push("/authorized-error");
                } else if (error.response.status === 500) {
                  this.$router.push("/server-error");
                } else {
                  this.$router.push("/page-not-found");
                }
              }
            });
        } else {
          this.isLoading = false;
        }
      });
    },

    cek_message(status, msg) {
      if (status == "200") {
        this.success(msg);
      }
    },

    editData() {
      var params = this.$route.params.id;
      window.location.href = "/billing-cml/master-tarif/edit/" + params;
    },

    backForm() {
      window.location.href = "/billing-cml/master-tarif";
    },

    loadData(id) {
      this.isLoading = true;

      const baseURI =
        this.$settings.endPointBilling +
        "dashboard/cml-billing/bm-tarif-master-cml/detail/" +
        id;
      return this.$http
        .get(baseURI, { timeout: 60000 })
        .then((response) => {
          this.isLoading = false;
          this.forms = response.data.datas;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    logout() {
      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 60000 }).then((response) => {
        console.log(response);
      });

      this.$logoutUser();
      window.location.href = "/";
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (
          permision.permission.controller == "BmTarifMasterHeaderController"
        ) {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
        // onShown: function() {
        //     console.log('asdasdasd');
        //     //window.location.href = '/';
        // }
      });

      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () { },
  mounted() {
    this.cek_message(this.$route.query.status, this.$route.query.msg);
    var params = this.$onBehind(this.$route.params.id);
    this.loadData(params[0]);
    this.fetchIt();
  },
};
</script>
<style scoped></style>
